import React, { useState, useEffect } from 'react';
import { Button, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import Select, { components } from 'react-select';
import styledComponent from '../../utils/styledComponent';
import { GetAvailableSoftwareVersions } from '../../libs/GraphQL';
import Loader from '../../components/atoms/Loader';
import {
  cleanVersion,
  sortArrayOfObjects,
  isCorrectAWSDate,
  getDeployableVersions,
} from './Utilities/ViewFridgeSoftware_utilities';
import HazardIcon from '../../assets/HazardIcon';

/*     STYLED COMPONENT     */

const StyledDiv = styledComponent('div', {
  '.toolBar': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '5px',
    gap: '0px',
    width: '1145px',
    background: '#FFFFFF',
    flex: 'none',
    alignSelf: 'stretch',
    flexGrow: '0',
    marginBottom: '10px',
    backgroundColor: '#F6F8F5',
    height: 'fit-content',
    justifyContent: 'flex-start',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
  },
  '.content': {
    width: 'stretch',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '5px',
    marginLeft: '10px',
  },
  '.text': {
    display: 'flex',
    width: '20%',
  },
  '.nonContentRow': {
    display: 'flex',
    flexDirection: 'row',
    width: 'stretch',
  },
  '.title': {
    display: 'flex',
    color: '#368007',
    fontWeight: '550',
    marginTop: '0px',
    marginLeft: '10px',
    marginBottom: '0px',
  },
  '.buttonWrapper': {
    display: 'flex',
    marginTop: '0px',
    marginRight: '20px',
    marginBottom: '0px',
  },
  '.fridgeText': {
    resize: 'none',
    height: '145px',
    width: '300px',
  },
  '.descText': {
    resize: 'none',
    height: '75px',
    width: '220px',
  },
  '.artifactColumn': {
    width: '240px',
  },
  '.pilotColumn': {
    display: 'flex',
    width: '150px',
    justifyContent: 'center',
    marginRight: '50px',
  },
  '.inputWrapper': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: '5px',
  },
  '#isPilotCheckbox': {
    position: 'relative',
    top: '0',
  },
  '& input[type=checkbox]': {
    width: '25px',
    height: '25px',
    marginLeft: '5px',
  },
  '& input': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    padding: '2px 2px',
    gap: '0px',
    width: '175px',
    height: '30px',
    background: '#FFFFFF',
    borderRadius: '4px',
    borderWidth: 'thin',
    flex: 'none',
    order: '1',
    alignSelf: 'stretch',
    flexGrow: '0',
    marginLeft: '5px',
  },
});

const DeploymentToolbar = (props) => {
  const [queryError, setQueryError] = useState(null);
  const [availableDeployments, setAvailableDeployments] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const retrieveVersions = async () => {
    const availableDeploymentsResponse =
      await GetAvailableSoftwareVersions().catch((e) => {
        console.log(e);
        setQueryError('availableVersions');
      });

    setIsLoading(false);

    if (availableDeploymentsResponse) {
      setAvailableDeployments(
        availableDeploymentsResponse.data.getAvailableFridgeArtifacts,
      );
    }
  };

  // When deployment toolbar is opened
  useEffect(() => {
    retrieveVersions();
  }, []);

  let fridgeTextboxCorrect = true;
  if (
    props.selectedFridges.size === 0 ||
    props.incorrectFridgeNames.length > 0 ||
    (props.selectedFridges.size === 1 &&
      Array.from(props.selectedFridges)[0] === '')
  ) {
    fridgeTextboxCorrect = false;
  }
  return (
    <StyledDiv>
      <div className="toolBar">
        <div style={{ justifyContent: 'flex-start' }} className="nonContentRow">
          <h3 className="title">Create Deployment</h3>
        </div>
        {queryError === 'availableVersions' && (
          <div>
            <h5>
              There was an error querying available versions, please refresh
              page and try again.{' '}
            </h5>
          </div>
        )}
        {!queryError && (
          <>
            {isLoading && (
              <div className="content">
                <Loader />
              </div>
            )}
            {!isLoading && (
              <div className="content">
                <div className="text">
                  <h4>
                    Select fridges from table AND/OR enter them in text box
                  </h4>
                </div>
                <div className="FridgeColumn">
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    {props.selectedFridges.size === 0 && <h5>0 Fridges</h5>}
                    {props.selectedFridges.size !== 0 &&
                      props.selectedFridges.has('') && (
                        <h5>
                          {props.selectedFridges.size -
                            1 -
                            props.incorrectFridgeNames.length}{' '}
                          Fridges
                        </h5>
                      )}
                    {props.selectedFridges.size !== 0 &&
                      !props.selectedFridges.has('') && (
                        <h5>
                          {props.selectedFridges.size -
                            props.incorrectFridgeNames.length}{' '}
                          Fridges
                        </h5>
                      )}
                    {props.incorrectFridgeNames.length > 0 && (
                      <div>
                        <OverlayTrigger
                          key="fridgeIdsHazard"
                          placement="right"
                          overlay={
                            <Popover id="tooltip-fridgeIdsHazard">
                              <div>
                                <h5 style={{ fontWeight: 'bold' }}>Error</h5>
                                <span>
                                  The following fridges IDs do not exist in the
                                  Locations table:
                                </span>
                                <br />
                                {props.incorrectFridgeNames.map((id) => {
                                  return (
                                    <span>
                                      {id}
                                      <br />
                                    </span>
                                  );
                                })}
                              </div>
                            </Popover>
                          }
                        >
                          <div
                            className="hazard"
                            data-testid="hazard"
                            style={{ display: 'flex' }}
                          >
                            <HazardIcon />
                          </div>
                        </OverlayTrigger>
                      </div>
                    )}
                  </div>
                  <textarea
                    className="fridgeText"
                    style={{
                      marginBottom: '0px',
                      borderWidth: '1px',
                      borderColor: fridgeTextboxCorrect ? '#368007' : '#FF123e',
                      outline: 'none',
                      background: '#EEEEEE',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                    }}
                    onChange={(e) => {
                      props.setSelectedFridges(
                        new Set([...e.target.value.split('\n')]),
                      );
                      props.setDeploymentInfo({
                        ...props.deploymentInfo,
                        deployment: {
                          ...props.deploymentInfo.deployment,
                          selectedFridges: new Set([
                            ...e.target.value.split('\n'),
                          ]),
                        },
                      });
                    }}
                    value={
                      props.deploymentInfo.deployment.selectedFridges
                        ? Array.from(
                            props.deploymentInfo.deployment.selectedFridges,
                          ).join('\n')
                        : null
                    }
                    placeholder="Enter each Fridge ID on a new line"
                  />
                </div>
                <div className="artifactColumn">
                  <div style={{ marginBottom: '5px' }}>
                    <p>Software</p>
                    <Select
                      options={availableDeployments}
                      getOptionLabel={(option) => option.artifactType}
                      onChange={(e) => {
                        props.setSelectedSoftware(e);
                        props.setDeploymentInfo({
                          ...props.deploymentInfo,
                          deployment: {
                            ...props.deploymentInfo.deployment,
                            selectedSoftware: e.artifactType,
                            selectedVersion: null,
                          },
                        });
                        props.disableDeploy(true);
                        const versionEntries = [];
                        e.availableVersions.map((version) => {
                          versionEntries.push({
                            rawVersion: version,
                            cleanVersion: cleanVersion(e.artifactType, version),
                          });
                        });

                        // Get all applicable versions (some objects in the S3 Bucket aren't)
                        const deployableVersions = getDeployableVersions(
                          e.artifactType,
                          versionEntries,
                        );

                        const sortedVersions = sortArrayOfObjects(
                          deployableVersions,
                          'cleanVersion',
                          'desc',
                        );
                        props.setVersionOptions(sortedVersions.slice(0, 5));
                      }}
                      value={props.selectedSoftware}
                    />
                  </div>
                  <p>Version</p>
                  <Select
                    options={props.versionOptions}
                    isSearchable
                    getOptionLabel={(option) => option.cleanVersion}
                    getOptionValue={(option) => option.rawVersion}
                    onChange={(e) => {
                      props.setDeploymentInfo({
                        ...props.deploymentInfo,
                        deployment: {
                          ...props.deploymentInfo.deployment,
                          selectedVersion: e,
                        },
                      });
                    }}
                    value={props.deploymentInfo.deployment.selectedVersion}
                  />
                </div>

                <div className="pilotColumn">
                  <div
                    style={{ flexDirection: 'row', alignItems: 'center' }}
                    className="inputWrapper"
                  >
                    <span style={{ fontSize: '18px' }}>Pilot?</span>
                    <div className="checkbox">
                      <input
                        key="isPilot"
                        type="checkbox"
                        id="isPilotCheckbox"
                        onChange={(e) => {
                          props.setIsPilot(!props.isPilot);
                          props.setDeploymentInfo({
                            ...props.deploymentInfo,
                            pilot: {
                              ...props.deploymentInfo.pilot,
                              isPilot: !props.deploymentInfo.pilot.isPilot,
                            },
                          });
                          console.log({
                            ...props.deploymentInfo,
                            pilot: {
                              ...props.deploymentInfo.pilot,
                              isPilot: !props.deploymentInfo.pilot.isPilot,
                            },
                          });
                        }}
                        checked={props.isPilot}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.isPilot && (
              <>
                <h4 className="title">Pilot Info</h4>
                <div className="content" style={{ marginRight: '10px' }}>
                  <div
                    className="inputWrapper"
                    style={{ justifyContent: 'space-between' }}
                  >
                    <span>Pilot ID</span>
                    <div className="input">
                      <input
                        type="text"
                        name="pilotID"
                        id="PilotID"
                        style={{
                          marginBottom: '0px',
                          borderWidth: '1px',
                          borderColor:
                            'id' in props.deploymentInfo.pilot &&
                            props.deploymentInfo.pilot.id !== ''
                              ? '#368007'
                              : '#FF123e',
                          outline: 'none',
                          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                        }}
                        onChange={(e) => {
                          props.setDeploymentInfo({
                            ...props.deploymentInfo,
                            pilot: {
                              ...props.deploymentInfo.pilot,
                              id: e.target.value,
                            },
                          });
                        }}
                        value={
                          props.deploymentInfo.pilot.id
                            ? props.deploymentInfo.pilot.id
                            : null
                        }
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div
                    className="inputWrapper"
                    style={{ justifyContent: 'space-between' }}
                  >
                    <span>Display Name</span>
                    <div className="input">
                      <input
                        type="text"
                        name="displayName"
                        id="displayName"
                        style={{
                          marginBottom: '0px',
                          borderWidth: '1px',
                          borderColor:
                            'displayName' in props.deploymentInfo.pilot &&
                            props.deploymentInfo.pilot.displayName !== ''
                              ? '#368007'
                              : '#FF123e',
                          outline: 'none',
                          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                        }}
                        onChange={(e) => {
                          props.setDeploymentInfo({
                            ...props.deploymentInfo,
                            pilot: {
                              ...props.deploymentInfo.pilot,
                              displayName: e.target.value,
                            },
                          });
                        }}
                        value={
                          props.deploymentInfo.pilot.displayName
                            ? props.deploymentInfo.pilot.displayName
                            : null
                        }
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div
                    className="inputWrapper"
                    style={{ justifyContent: 'space-between' }}
                  >
                    <span>Pilot Stage</span>
                    <div className="input">
                      <input
                        type="text"
                        name="pilotStage"
                        id="pilotStage"
                        style={{
                          width: '50px',
                          marginBottom: '0px',
                          outline: 'none',
                          borderWidth: '1px',
                          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                          borderColor:
                            'stage' in props.deploymentInfo.pilot &&
                            Number.isInteger(props.deploymentInfo.pilot.stage)
                              ? '#368007'
                              : '#FF123e',
                        }}
                        onChange={(e) => {
                          props.setDeploymentInfo({
                            ...props.deploymentInfo,
                            pilot: {
                              ...props.deploymentInfo.pilot,
                              stage: parseInt(e.target.value),
                            },
                          });
                        }}
                        value={
                          props.deploymentInfo.pilot.stage
                            ? props.deploymentInfo.pilot.stage.toString()
                            : null
                        }
                        placeholder="e.g. 1"
                      />
                    </div>
                  </div>
                  <div
                    className="inputWrapper"
                    style={{ justifyContent: 'space-between' }}
                  >
                    <span>Start Date</span>
                    <div className="input">
                      <input
                        type="text"
                        name="startDate"
                        id="startDate"
                        style={{
                          width: '100px',
                          marginBottom: '0px',
                          borderWidth: '1px',
                          borderColor:
                            'startDate' in props.deploymentInfo.pilot &&
                            isCorrectAWSDate(
                              props.deploymentInfo.pilot.startDate,
                            )
                              ? '#368007'
                              : '#FF123e',
                          outline: 'none',
                          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                        }}
                        onChange={(e) => {
                          props.setDeploymentInfo({
                            ...props.deploymentInfo,
                            pilot: {
                              ...props.deploymentInfo.pilot,
                              startDate: e.target.value,
                            },
                          });
                        }}
                        value={
                          props.deploymentInfo.pilot.startDate
                            ? props.deploymentInfo.pilot.startDate
                            : null
                        }
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                  </div>
                  <div
                    className="inputWrapper"
                    style={{ justifyContent: 'space-between' }}
                  >
                    <span>End Date</span>
                    <div className="input">
                      <input
                        type="text"
                        name="endDate"
                        id="endDate"
                        style={{
                          width: '100px',
                          marginBottom: '0px',
                          borderWidth: '1px',
                          borderColor:
                            'endDate' in props.deploymentInfo.pilot &&
                            isCorrectAWSDate(props.deploymentInfo.pilot.endDate)
                              ? '#368007'
                              : '#FF123e',
                          outline: 'none',
                          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                        }}
                        onChange={(e) => {
                          props.setDeploymentInfo({
                            ...props.deploymentInfo,
                            pilot: {
                              ...props.deploymentInfo.pilot,
                              endDate: e.target.value,
                            },
                          });
                        }}
                        value={
                          props.deploymentInfo.pilot.startDate
                            ? props.deploymentInfo.pilot.endDate
                            : null
                        }
                        placeholder="YYYY-MM-DD"
                      />
                    </div>
                  </div>
                  <div
                    className="inputWrapper"
                    style={{ justifyContent: 'space-between' }}
                  >
                    <span>Description</span>
                    <div className="input">
                      <textarea
                        className="descText"
                        style={{
                          marginBottom: '0px',
                          borderWidth: '1px',
                          outline: 'none',
                          borderColor:
                            'description' in props.deploymentInfo.pilot &&
                            props.deploymentInfo.pilot.description !== ''
                              ? '#368007'
                              : '#FF123e',
                          background: '#EEEEEE',
                          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                        }}
                        onChange={(e) => {
                          props.setDeploymentInfo({
                            ...props.deploymentInfo,
                            pilot: {
                              ...props.deploymentInfo.pilot,
                              description: e.target.value,
                            },
                          });
                        }}
                        value={
                          props.deploymentInfo.pilot.description
                            ? props.deploymentInfo.pilot.description
                            : null
                        }
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div
              style={{ justifyContent: 'flex-end' }}
              className="nonContentRow"
            >
              <div className="buttonWrapper">
                <Button
                  onClick={() => {
                    props.setShowDeploymentToolbar(false);
                    props.disableDeploy(true);
                  }}
                  style={{
                    height: '35px',
                    marginRight: '30px',
                    backgroundColor: '#F6F8F5',
                    color: '#368007',
                    border: 'none',
                    outline: 'none',
                    hover: 'none',
                    boxShadow: 'none',
                  }}
                >
                  CANCEL
                </Button>
                <Button
                  disabled={props.isDeployDisabled}
                  onClick={() => {
                    props.setShowConfirmationModal(true);
                  }}
                  style={{
                    color: '#FFFFFF',
                    border: 'none',
                    backgroundColor: '#368007',
                    outline: 'none',
                    height: '35px',
                    paddingLeft: '25px',
                    paddingRight: '25px',
                  }}
                >
                  DEPLOY
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
    </StyledDiv>
  );
};

export default DeploymentToolbar;
